var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"id":"map","space":"0"}},[_c('iframe',{staticStyle:{"border":"0","display":"block"},attrs:{"allowfullscreen":"","aria-hidden":"false","frameborder":"0","height":"500","src":_vm.src,"tabindex":"0","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }